import ruLayout from "simple-keyboard-layouts/build/layouts/russian";
import enLayout from "simple-keyboard-layouts/build/layouts/english";

const langs = {
	ru : {
		default : [...ruLayout.layout.default],
		shift : [...ruLayout.layout.shift]
	},
	en : {
		default : [...enLayout.layout.default],
		shift : [...enLayout.layout.shift]
	}
};

langs.ru.default[4] +=  ' {lang_en}';
langs.ru.shift[4] += ' {lang_en}';
langs.en.default[4] += ' {lang_ru}';
langs.en.shift[4] += ' {lang_ru}';

export default langs;